import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

/**
 * Account page now redirects to /settings.
 * Preserves query params (e.g., ?checkout=success from Stripe).
 */
const Account = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const queryString = searchParams.toString();
    const redirectUrl = queryString ? `/settings?${queryString}` : "/settings";
    navigate(redirectUrl, { replace: true });
  }, [navigate, searchParams]);

  return null;
};

export default Account;
